import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import { ShareArticleSection } from "../ShareArticleSection";

const PioneeringOmnichannelCloudContactCenterWithAmazonConnectForShippingAndLogistics =
  () => {
    return (
      <div className="modal-content-body case-studies-blk">
        <div className="modal-section">
          <div className="flex-content header-modal-case-studies">
            <div className="logo-section-modal">
              <img
                src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/chelsea-thumbnail-iris.png"
                alt="Scene to believe"
              />
            </div>
            <div>
              <h3>
                Pioneering Omnichannel Cloud Contact Center with Amazon Connect
                for Shipping and Logistics
              </h3>
              <p>
                Chelsea Logistics partnered with iCXeed to launch Amazon Connect
                in the Philippines, delivering an AI-powered omnichannel support
                solution with 24/7 self-service and real-time tracking.
              </p>
              <ShareArticleSection />
            </div>
          </div>
        </div>

        {/* Opportunity & Qualification */}
        <div className="modal-section">
          <h2 className="modal-section-title">Company Snapshot:</h2>
          <p className="title-description-blk">
            Chelsea Logistics partnered with iCXeed to become the first company
            in the Philippines to go live with Amazon Connect for both voice and
            messaging channels. This implementation transformed their customer
            support operations by deploying an AI-powered omnichannel contact
            centre solution, enabling 24/7 self-service, real-time tracking
            capabilities, and seamless support across voice, chat, social media,
            and email platforms.
          </p>
        </div>

        {/* Proposed Solution */}
        <div className="modal-section">
          <div className="flex-content-half">
            <div>
              <h2 className="modal-section-title">Challenge:</h2>
              <p className="text-[#CDCFD3]">
                As a leading shipping and logistics company in the Philippines,
                Chelsea Logistics recognized the need to modernise their
                customer contact centre infrastructure to meet the evolving
                expectations of Filipino travelers and cargo customers.
              </p>

              <br />

              <p className="text-[#CDCFD3]">
                The company faced several critical challenges:{" "}
              </p>
              <ul className="text-[#CDCFD3]">
                <li>
                  • Limited channel availability - customers could only reach
                  support through traditional voice channels
                </li>
                <li>
                  • Inability to provide 24/7 support for time-sensitive queries
                  about sailing schedules, bookings, and cargo tracking
                </li>
                <li>
                  • No self-service options, resulting in high call volumes for
                  routine inquiries
                </li>
                <li>
                  • Lack of unified customer experience across different
                  touchpoints
                </li>
                <li>
                  • Need for scalable, cloud-based infrastructure to support
                  business growth
                </li>
                <li>
                  • Desire to leverage AI and automation to improve response
                  times and operational efficiency
                </li>
                <li>
                  • Requirement to maintain service quality while handling
                  increasing customer interaction volumes
                </li>
              </ul>

              <p>
                Chelsea Logistics sought a partner who could deliver a
                comprehensive cloud contact centre solution tailored to the
                unique needs of the Philippine shipping and logistics industry,
                while ensuring resilience, security, and responsiveness aligned
                with their fast-paced operations.
              </p>
            </div>
            <div>
              <h2 className="modal-section-title">AWS Solution:</h2>
              <p className="text-[#CDCFD3]">
                iCXeed designed and implemented a comprehensive omnichannel
                contact centre solution leveraging Amazon Connect and AWS
                services.
              </p>
              <p className="font-bold">Core Solution Architecture</p>
              <p className="font-bold">Omnichannel Contact Centre Deployment</p>
              <ul className="text-[#CDCFD3]">
                <li>
                  • Deployed Amazon Connect as the foundation for unified
                  customer interactions across voice, chat, social media, and
                  email
                </li>
                <li>
                  • Leveraged AWS's newly-launched local carrier integration for
                  seamless Philippine telecommunications connectivity
                </li>
                <li>
                  • Configured contact flows specifically tailored to Filipino
                  traveler needs and shipping industry requirements
                </li>
                <li>
                  • Established unified routing to ensure consistent,
                  high-quality service regardless of customer's preferred
                  platform
                </li>
              </ul>

              <p className="font-bold">Generative AI-Powered Self-Service</p>
              <ul className="text-[#CDCFD3]">
                <li>
                  • Built intelligent bot capabilities using Amazon Connect's
                  built-in Generative AI features
                </li>
                <li>
                  • Enabled 24/7 automated responses to common customer queries:
                  <ul>
                    <li>• Real-time sailing schedules </li>
                    <li>• Booking status updates </li>
                    <li>• Live cargo tracking </li>
                  </ul>
                </li>
                <li>
                  • Implemented conversational AI that can resolve complex
                  issues automatically, significantly reducing customer wait
                  times
                </li>
              </ul>

              <p className="font-bold">Enhanced Agent Experience </p>
              <ul className="text-[#CDCFD3]">
                <li>
                  • Deployed AI-powered sentiment detection to identify customer
                  emotions in real-time
                </li>
                <li>
                  • Implemented automatic chat summarization for faster context
                  understanding
                </li>
                <li>
                  • Enabled supervisors to identify where support is needed and
                  intervene proactively
                </li>
                <li>
                  • Provided agents with intelligent tools to improve support
                  quality and efficiency
                </li>
              </ul>

              <p>
                This implementation represented a natural extension of Chelsea
                Logistics' existing cloud strategy with AWS, reinforcing their
                commitment to digital transformation across their infrastructure
                and operations.
              </p>
            </div>
          </div>
        </div>

        <div className="outcomes-result-blk">
          <h2 className="modal-section-title">Outcomes/Results:</h2>
          <ul>
            <li>
              <div className="flex-box-blk">
                <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
                <p>Always-on, efficient operations </p>
              </div>
            </li>
            <li>
              <div className="flex-box-blk">
                <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
                <p>Superior omnichannel customer journeys</p>
              </div>
            </li>
            <li>
              <div className="flex-box-blk">
                <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
                <p>Pioneering innovation in the Philippines</p>
              </div>
            </li>
            <li>
              <div className="flex-box-blk">
                <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
                <p>Stronger business intelligence</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  };

export default PioneeringOmnichannelCloudContactCenterWithAmazonConnectForShippingAndLogistics;
